import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import {Alert, Icon, Layout, Input } from 'antd';
import { Helmet } from 'react-helmet';

import AdminHeader from '../../components/AdminHeader/AdminHeader';
import Footer from '../../components/Footer/Footer';
import FollowUp30DayForm from '../../components/FollowUp30DayForm/FollowUp30DayForm';

import classes from './FollowUp30Day.css';

import isAuthenticated from '../../utils/isAuthenticated';
import { getFollowUp30Request } from '../../api/requests';
import { logout } from "../../reducers/user/actions";
import {getFollowUp30dReadPermission } from "../../reducers/user/selectors";
import FollowUp7DayForm from "../../components/FollowUp7DayForm/FollowUp7DayForm";
import { withNamespaces } from 'react-i18next';

const { Content } = Layout;
const { Search } = Input;


class FollowUp30Day extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      subject: null,
      subjectID: null,
      errorMessage: null,
      isLoading: false,
    };
  }

  componentDidMount() {
    if (get(this.props, 'match.params.subjectID')) {
      this.onFollowUpSearch(get(this.props, 'match.params.subjectID'));
    }
  }

  onFollowUpSearch = async (value) => {
    if (value.trim()) {
      this.setState({ subjectID: value, errorMessage: null, subject: null, isLoading: true });
      try {
        const {data} = await getFollowUp30Request(value);
        this.setState({
          subject: {...data},
        });
      } catch (e) {
        if (get(e, 'response.status') === 401) {
          this.props.logout();
          return;
        }
        this.setState({subject: null, errorMessage: get(e, 'response.data.error', 'Error')});
      }

      this.setState({isLoading: false});
    }
  };

  onSubjectClear = () => {
    this.setState({
      subject: null,
      subjectID: null
    });
  };

  render() {
    const { subject, subjectID, errorMessage, isLoading } = this.state;
    const { followUp30dReadPermission } = this.props;

    return (
      <div style={{ backgroundColor: '#FAFAFA' }}>
        <Helmet>
          <title>{this.props.i18n.t('Trial Management Portal')}: {this.props.i18n.t('30-day Follow Up')}</title>
        </Helmet>
        <Layout className={classes.parentContainer}>

          <Content className={classes.content}>
            <h3 className='headline-default'>{this.props.i18n.t('30-day Follow Up')}</h3>

            {!followUp30dReadPermission && (<Alert type='error' message={this.props.i18n.t('Permission denied! You cannot perform this action.')} />)}

            {followUp30dReadPermission && (<div>
              <div className={classes.searchWrapper}>
                <label>
                  <b className={classes.searchWrapperLabel}>{this.props.i18n.t('SEARCH')}</b>
                  <Search
                    placeholder={this.props.i18n.t('By subject ID')}
                    enterButton={this.props.i18n.t('Search')}
                    size="large"
                    onSearch={this.onFollowUpSearch}
                    style={{ maxWidth: '500px'}}
                  />
                </label>
              </div>

              {errorMessage && (<Alert type='error' message={errorMessage} />)}

              {subject && <FollowUp30DayForm history={this.props.history} onSubjectClear={this.onSubjectClear} {...subject} subjectID={subjectID} onSubmit={this.onFollowUpSearch} />}

              {isLoading && <Icon type="loading" />}
            </div>)}

          </Content>

        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  followUp30dReadPermission: getFollowUp30dReadPermission(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(FollowUp30Day)));



// WEBPACK FOOTER //
// ./src/containers/FollowUp30Day/FollowUp30Day.js